/**
 * Authenticated API Client Configuration
 * 
 * This module provides a configured fetch implementation that automatically
 * includes the Clerk JWT token in all API requests.
 */

/**
 * Custom fetch implementation that automatically adds Authorization header
 * Token is provided dynamically via the getToken function
 */
export class AuthenticatedFetch {
  private getToken: (() => Promise<string | null>) | null = null;

  /**
   * Set the token provider function (typically Clerk's getToken)
   */
  setTokenProvider(getToken: () => Promise<string | null>) {
    this.getToken = getToken;
  }

  async fetch(url: RequestInfo, init?: RequestInit): Promise<Response> {
    let token: string | null = null;
    
    // Get token from provider if available
    if (this.getToken) {
      token = await this.getToken();
    }
    
    const headers = {
      ...(init?.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    const modifiedInit: RequestInit = {
      ...init,
      headers,
    };

    return window.fetch(url, modifiedInit);
  }
}

// Export a singleton instance
export const authenticatedFetch = new AuthenticatedFetch();

/**
 * Get the base URL for API requests
 * Defaults to empty string which uses relative URLs
 */
export const getApiBaseUrl = (): string | undefined => {
  return process.env.REACT_APP_API_BASE_URL || undefined;
};
